import { Type } from 'class-transformer';

export class CalendarYearStatContractRes {
    userId!: number;
    year!: number;

    currentIsoWeek!: number;
    currentIsoYear!: number;

    weeklyTargetHours!: number;
    workdaysPerWeek!: number;
    targetHoursPerDay!: number;

    vacationDaysEntitlement!: number;
    vacationDaysTaken!: number;
    vacationDaysRemaining!: number;
    vacationDaysRemainingRaw!: number;

    vacationDaysPlanned!: number;
    vacationDaysPlannedApproved!: number;
    vacationDaysPlannedPending!: number;

    expectedHoursYear!: number;
    availableWorkingHoursYear!: number;
    totalWorkedHoursYear!: number;
    averageWorkedHoursPerAvailableWorkdayYear!: number;
    availableWorkingDaysForAverageYear!: number;
    averageWorkedHoursPerAvailableWorkweekYear!: number;
    availableWorkingWeeksForAverageYear!: number;
    totalCreditablePerformanceHoursYear!: number;
    totalPublicHolidayCreditHoursYear!: number;
    currentOvertimeHours!: number;
    currentOvertimeHoursRaw!: number;
    totalOvertimeHoursYear!: number;

    publicHolidayDaysCount!: number;
    possibleWorkingDaysCountYear!: number;
    sickDays!: number;

    @Type(() => CalendarTimePolicyBalanceContractRes)
    timePolicyBalance!: CalendarTimePolicyBalanceContractRes;

    @Type(() => CalendarWeekStatContractRes)
    weeks: CalendarWeekStatContractRes[] = [];
    @Type(() => CalendarMonthStatContractRes)
    months: CalendarMonthStatContractRes[] = [];
}

export class CalendarTimePolicyBalanceContractRes {
    userId!: number;
    year!: number;

    @Type(() => Date)
    asOfUtc!: Date;

    @Type(() => CalendarVacationTimePolicyBalanceContractRes)
    vacation!: CalendarVacationTimePolicyBalanceContractRes;

    @Type(() => CalendarOvertimeTimePolicyBalanceContractRes)
    overtime!: CalendarOvertimeTimePolicyBalanceContractRes;
}

export class CalendarVacationTimePolicyBalanceContractRes {
    entitlementDaysCurrentYear!: number;

    carryOverDaysFromPreviousYear!: number;
    carryOverDaysUsedApproved!: number;
    carryOverDaysUsedPending!: number;
    carryOverDaysExpired!: number;
    carryOverDaysRemaining!: number;

    currentYearDaysUsedApprovedOrTaken!: number;
    currentYearDaysPlannedPending!: number;

    availableDaysNow!: number;
    eligibleCarryOverDaysAtYearEnd!: number;

    @Type(() => Date)
    carryOverDeadlineUtc?: Date | null;
}

export class CalendarOvertimeTimePolicyBalanceContractRes {
    rawCurrentOvertimeHours!: number;
    rawYearOvertimeHours!: number;

    carryOverHoursFromPreviousYear!: number;
    carryOverHoursUsedApproved!: number;
    carryOverHoursUsedPending!: number;
    carryOverHoursExpired!: number;
    carryOverHoursRemaining!: number;

    availableHoursNow!: number;
    eligibleCarryOverHoursAtYearEnd!: number;

    @Type(() => Date)
    carryOverDeadlineUtc?: Date | null;
}

export class CalendarMonthStatContractRes {
    year!: number;
    month!: number;

    @Type(() => Date)
    monthStartUtc!: Date;

    @Type(() => Date)
    monthEndUtc!: Date;

    expectedHours!: number;
    availableWorkingHours!: number;
    workedHours!: number;
    forecastWorkedHours!: number;
    averageWorkedHoursPerWorkday!: number;
    previousMonthAverageWorkedHoursPerWorkday!: number;
    averageWorkedHoursDeltaPercent?: number | null;
    creditablePerformanceHours!: number;
    remainingHours!: number;
    overtimeHours!: number;
    overtimeBalanceBeforeMonth!: number;
    overtimeBalanceAfterMonth!: number;
    possibleWorkingDaysCount!: number;
    elapsedWorkingDaysCount!: number;
}

export class CalendarWeekStatContractRes {
    isoYear!: number;
    isoWeek!: number;

    @Type(() => Date)
    weekStartUtc!: Date;

    @Type(() => Date)
    weekEndUtc!: Date;

    expectedHours!: number;
    availableWorkingHours!: number;
    workedHours!: number;
    creditablePerformanceHours?: number;
    absenceCreditHours!: number;
    publicHolidayCreditHours?: number;
    overtimeHours!: number;
    remainingHours!: number;

    overtimeBalanceBeforeWeek!: number;
    overtimeBalanceAfterWeek!: number;
    adjustedExpectedHours!: number;

    publicHolidayDaysCount!: number;
    possibleWorkingDaysCount!: number;
    sickDays!: number;
}

export class CalendarStatsQueryReq {
    userId?: number;
    year?: number;

    constructor(val: Partial<CalendarStatsQueryReq>) {
        Object.assign(this, val);
    }
}